import React, { useState, useEffect } from "react";
import FontBase from "./font-base/font-base";
import Text from "./text/text";
import CreateComponent from "./create-component/create-component";
import ImageComponent from "./image-component/image-component";
import LineChartComponent from "./line-chart-component/line-chart";
import PieChartComponent from "./pie-chart-component/pie-chart-component";
import TableComponent from "./table-component/table-component";
import SpaceComponent from "./space-component.jsx/space-component";
import s from "./report-components.module.scss"
import { StandartButton } from "commons/form-controls";
import ComponentHeaderButtons from "../items/component-header-buttons/component-header-buttons";
import { ReactComponent as AngleUp } from 'assets/icons/angle-up.svg';
import { ReactComponent as AngleDown } from 'assets/icons/angle-down.svg';
import SaveButton from "../items/save-button/save-button";
import Feeds from "./feeds/feeds";
import { InputText } from "commons/input-controls";
import Period from "./period/period";
import Preview from "../items/preview/preview";
import LogoComponent from "./logo-component/logo-component";


const ReportComponents = (props) => {
    const [showedBlocks, setShowedBlocks] = useState(null);
    const [rerender, setRerender] = useState(false);
    const [id, setId] = useState(props.selectedReport && props.selectedReport.id ? props.selectedReport.id : null);
    const [title, setTitle] = useState(props.selectedReport && props.selectedReport.name ? props.selectedReport.name : '');
    const [parameters, setParameters] = useState(props.selectedReport && props.selectedReport.parameters ? props.selectedReport.parameters : null);
    const [components, setComponents] = useState(props.selectedReport && props.selectedReport.components ? props.selectedReport.components : []);
    const [showAddComponents, setShowAddCoponents] = useState(false);
    const [isReadOnly, setIsReadOnly] = useState(props.isReadOnly);
    const [newComponents, setNewComponents] = useState([]);
    const [draggableElement, setDraggableElement] = useState();

    useEffect(() => {
        setParameters(props.selectedReport && props.selectedReport.parameters ? props.selectedReport.parameters : null);
        setComponents(props.selectedReport && props.selectedReport.components ? props.selectedReport.components : []);
        setId(props.selectedReport && props.selectedReport.id ? props.selectedReport.id : null);
        setTitle(props.selectedReport && props.selectedReport.name ? props.selectedReport.name : '');
        setIsReadOnly(props.isReadOnly);
        setNewComponents([]);
        setRerender(!rerender);
        //setShowedBlocks(null);
    }, [props]);

    const removeComponent = (type, index) => {
        switch(type){
            case 'delete':
                let allComponents = components;
                let component = allComponents[index];
                allComponents.splice(index, 1)
                setComponents(allComponents);
                setRerender(!rerender)
                break;
            case 'move':
                setDraggableElement(index);
            break;
        }
    }

    const getComponentsName = (componentsItems) => {
        return componentsItems.map( k => props.getValue(k.type) );
    }

    /*const headerButtons = (index) => {return  <div className={s.ReportComponentsHeaderButtons}>
                                <div className={s.ReportControlButtons}>
                                    <StandartButton icon={EditIcon} background={'var(--background)'}/>
                                    <StandartButton icon={CloselIcon} background={'var(--background)'} callback={removeComponent}/>
                                    <StandartButton icon={ResizelIcon} background={'white'} callback={removeComponent}/>
                                </div>
                                
                            </div>}*/

    const showBlock = (index) => {
        if(showedBlocks !== index){
            setShowedBlocks(index);
        }
        else{
            setShowedBlocks(null);
        }
        /*let showedBlocksItems = showedBlocks;
        
        if(showedBlocksItems.indexOf(blockName) === -1){
            showedBlocksItems = [blockName];
            
        }
        else{
            showedBlocksItems.splice(showedBlocksItems.indexOf(blockName), 1)
        }
        /*if(showedBlocksItems.indexOf(blockName) === -1){
            showedBlocksItems.push(blockName);
            
        }
        else{
            showedBlocksItems.splice(showedBlocksItems.indexOf(blockName), 1)
        }*/
        //setShowedBlocks(showedBlocksItems);
        setRerender(!rerender)
    }

    /*const getBlockHeader = (blockName, index) => {
        return  <div className={s.reportRowHeader}>

                    <div className={s.showBlock} onClick={showBlock.bind(this, blockName)}>
                        <span>{props.getValue(blockName)}</span>
                        { showedBlocks.indexOf(blockName) === -1 ? <button><AngleUp /></button> : <button><AngleDown /></button> }
                    </div>
                    { headerButtons.bind(this, index) }
                </div>
    }*/

    const toggleShowAddComponents = () => {
        setShowAddCoponents(!showAddComponents);
    }

    const getReportComponent = (componentName) => {
        return props.reportComponents[componentName];
    }

    const addNewComponents = (component) => {
        setShowedBlocks(component)
        components.push(props.reportComponents[component])
        //props.addNewComponent(component);
    }

    const addParameters = (parameters) => {
        props.addParameters(parameters);
    }

    const updateTitle= (e) => {
        setTitle(e)
    }

    const updateParameters = (type, parameter, value) => {
        let params = parameters;
        params[type][parameter] = value;
        setParameters(params);
    }

    const checkComponent = (component) => {
        if(component && component.type == "IMAGE" && (component.parameters && (component.parameters.IMAGE_BASE === "" || component.parameters.IMAGE_FORMAT === ""))){
            return false
        }
        else return true;
    }

    const updateTemplateComponents = () => {
        let checkedComponents = components.filter(checkComponent);
        props.updateReportConstructorTemplateComponents(id, checkedComponents);
    }

    
    const removeParameterFromComponent = (index, type) => {
        let comps = components; 
        let component = comps[index];
        let param = component.parameters;
        delete param[type];
        component.parameters = param;
        comps[index] = component;
        setComponents(comps)
        setRerender(!rerender);
    }

    const addParameterToComponent = (index, type) => {
        let comps = components; 
        let component = comps[index];
        component.parameters[type] = props.reportParameters.FONT_PARAMETERS;
        comps[index] = component;
        setComponents(comps)
        setRerender(!rerender);
    }
    
    const handleDrop = (e, i) => {
        let params = components;
        let newE = params[draggableElement];
        params.splice(draggableElement, 1);
        params.splice(i+1, 0, params[i]);
        params[i] = newE;
        setComponents(params)
        setRerender(!rerender)
    }

    const onStartDrag = () => {

    }

    const handleOverDrag = (e, i) => {

    }

    const updateTemplateName = (index, name, value) => {
        let allComponents = components;
        let component = allComponents[index];
        component.parameters.TITLE = value;
        allComponents[index] = component;
        setComponents(allComponents);
    }

    const updateComponent = (index, parameters) => {
        /*let cmpnts = [...components]
        let comps = [...cmpnts];
        let component = {...comps[index]};
        component.parameters = {...parameters};
        comps[index] = component;
        setComponents(comps);
        setRerender(!rerender)*/
        props.updateTemplateComponents(index, parameters)
    }

    const getBlocks = (name, parameters, i) => {
        let componentBlock = <div></div>;
        switch(name){
            case 'TEXT':
                componentBlock = <Text 
                                        getValue={props.getValue} 
                                        isReadOnly={isReadOnly} 
                                        parameters={{...components[i]}} 
                                        updateComponent={updateComponent} 
                                        colors={props.colors} 
                                        index={i} 
                                        removeParameter={removeParameterFromComponent} 
                                        addParameter={addParameterToComponent}/>
                break;
            case 'AVAILABLE_COMPONENTS':
                componentBlock = <CreateComponent getValue={props.getValue} isReadOnly={isReadOnly} parameters={{...parameters}} reportComponents={props.reportComponents} addNewComponents={addNewComponents}/>
                break;
            case 'IMAGE':
                componentBlock = <ImageComponent 
                                                getValue={props.getValue} 
                                                isReadOnly={isReadOnly} 
                                                {...parameters} 
                                                updateComponent={updateComponent} 
                                                index={i} 
                                                updateTemplateComponents={updateTemplateComponents}/>
                break;
            case 'BAR_CHART':
            case 'LINE_CHART':
                componentBlock = <LineChartComponent 
                                                getValue={props.getValue} 
                                                isReadOnly={isReadOnly} 
                                                parameters={{...parameters}} 
                                                updateTemplateComponents={updateTemplateComponents}
                                                updateComponent={updateComponent}
                                                dateFields={props.dateFields}
                                                index={i} 
                                            />
                break;
            case 'PIE_CHART':
                componentBlock = <PieChartComponent 
                                                getValue={props.getValue} 
                                                isReadOnly={isReadOnly} 
                                                parameters={{...parameters}} 
                                                updateTemplateComponents={updateTemplateComponents}
                                                updateComponent={updateComponent} 
                                                index={i} 
                                            />
                break;
            case 'TABLE':
                componentBlock = <TableComponent 
                                                getValue={props.getValue} 
                                                isReadOnly={isReadOnly} 
                                                {...parameters} 
                                                fonts={props.fonts} 
                                                colors={props.colors} 
                                                updateTemplateComponents={updateTemplateComponents} 
                                                index={i} 
                                                removeParameter={removeParameterFromComponent} 
                                                addParameter={addParameterToComponent}
                                                updateComponent={updateComponent} 
                                            />
                break;
            case 'PAGE_BREAK':
            case 'VERTICAL_GAP':
                componentBlock = <SpaceComponent getValue={props.getValue} isReadOnly={isReadOnly} {...parameters} updateTemplateComponents={updateTemplateComponents}/>
                break;
            case 'FEED':
                componentBlock = <Feeds getValue={props.getValue} 
                                        {...parameters} 
                                        fonts={props.fonts} 
                                        colors={props.colors} 
                                        fields={props.fields} 
                                        updateTemplateComponents={updateTemplateComponents} 
                                        textRepresentationList={props.textRepresentationList} 
                                        groupingTypeList={props.groupingTypeList} 
                                        documentElementsList={props.documentElementsList}
                                        includeTocList={props.includeTocList}
                                        isReadOnly={isReadOnly}
                                        index={i} 
                                        removeParameter={removeParameterFromComponent} 
                                        addParameter={addParameterToComponent}
                                        updateComponent={updateComponent}
                                        selectedLanguage={props.selectedLanguage}
                                        feedSettings={props.feedSettings}
                                    />
                break;
            case 'DATE_RANGE':
            case 'DOCUMENT_NUMFOUND':
            case 'TOPIC_NAME':
                componentBlock = <Period 
                                        getValue={props.getValue} 
                                        {...parameters} 
                                        isReadOnly={isReadOnly}
                                        index={i}
                                        updateComponent={updateComponent}
                                        removeParameter={removeParameterFromComponent} 
                                        addParameter={addParameterToComponent}
                                    />
                break;
            case 'LOGO':
                componentBlock = <LogoComponent
                                        getValue={props.getValue}
                                        {...parameters}
                                        isReadOnly={isReadOnly}
                                        index={i}
                                        updateComponent={updateComponent}
                                        updateTemplateComponents={updateTemplateComponents}
                                    />
        }
        return  <div key={i} className={s.reportRow} onDragOver={(e) => {e.preventDefault(); handleOverDrag.bind(this, i)}} onDragStart={onStartDrag} onDrop={e => {e.preventDefault(); handleDrop(e, i)}}>
                    <div className={s.componentName} onClick={showBlock.bind(this, i)}>
                        <span>{props.getValue(name)}</span>
                        { showedBlocks == i 
                                            ? <button><AngleUp /></button> 
                                            : <button><AngleDown /></button>
                        }
                    </div>
                        {isReadOnly ? null : <ComponentHeaderButtons draggableIndex={draggableElement} index={i} callback={removeComponent} title={name}/>}
                            {showedBlocks == i ? <div className={s.reportBlock}>  
                                                    <div className={s.reportRowInner}>
                                                        {parameters && parameters.parameters && (parameters.parameters.TITLE || parameters.parameters.TITLE == "" )? <div className={s.templateName}>
                                                            {parameters && (parameters.parameters.TITLE || parameters.parameters.TITLE == "") ? <span>{props.getValue('NAME')}</span> : ''}
                                                            <InputText readOnly={isReadOnly} value={parameters && parameters.parameters.TITLE ? parameters.parameters.TITLE : ''} callback={updateTemplateName.bind(this, i, {...parameters})}/>
                                                        </div> : null}
                                                        {componentBlock}
                                                    </div> 
                                                </div> 
                                            : <div></div> }
                </div>
    }

    const updateReportTemplate = (name, parameterss) => {
        props.updateReportConstructor(id, title, parameters)
    }

    return (
        <div className={s.ReportComponents}>
            {props.selectedReport 
                        ?   <div className={s.ReportConstructor} title={title}>
                                <span>{props.getValue('REPORT_CONSTRUCTOR')}</span>
                                <InputText styles={{width: '300px'}} readOnly={isReadOnly} value={title} callback={updateTitle}/>
                                {!isReadOnly ? <StandartButton disabled={!title || title === ''} title={props.getValue('SAVE')} callback={updateReportTemplate}/> : null}
                                {/*<StandartButton title={props.getValue('CANCEL')} background={'white'}/>*/}
                            </div> 
                        : null }

            { parameters && parameters.FONT_PARAMETERS ?
                <FontBase getValue={props.getValue} fonts={props.fonts} colors={props.colors} parameters={parameters.FONT_PARAMETERS} updateParameters={updateParameters} type={'FONT_PARAMETERS'}/>
            : null }
            <div className={s.reportTemplate}>
                <div>
                    <div className={s.ReportComponentsHeader}>
                        <span>{ props.getValue('REPORT_COMPONENTS') }</span>
                    </div>
                </div>
                <div className={s.ReportComponentsList}>
                                    {components ? 
                                <div>
                                    <Preview items={components && components.length ? getComponentsName(components) : []}/>
                                </div> 
                            : null}
                    {components && components.length 
                    ? components.map((k, i) => <div key={i} draggable={draggableElement == i} className={s.componentBlock}>
                        <span>{i+1}</span>{getBlocks(k.type, {...k}, i)}
                    </div>)
                    : null }
                    {/* showAddComponents ? <div>
                        {getBlocks('AVAILABLE_COMPONENTS', components)}
                    </div> : <div></div> */}
                    {
                        showAddComponents ? <div className={s.AvailableComponents}>
                            <CreateComponent getValue={props.getValue} isReadOnly={isReadOnly} parameters={{...components}} reportComponents={props.reportComponents} addNewComponents={addNewComponents}/>
                        </div> : null
                    }
                    {props.selectedReport ? <div className={s.reportRow}>
                        { !props.createdStatus && props.createdStatus === "FAILED" ? <span className={s.errorMessage}>{ props.getValue('REPORT_CONSTRUCTOR_ERROR') }</span> : '' }
                        {!isReadOnly ? <SaveButton disabled={!title || title === ''} callback={updateTemplateComponents} title={props.getValue('SAVE')}/> : null}
                        <StandartButton title={props.getValue('ADD_MORE_COMPONENTS')} callback={toggleShowAddComponents}/>
                    </div> : null}
                </div>
            </div>
        </div>
    )
}

export default ReportComponents;
